import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "chat-group-title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ChatsItem = _resolveComponent("ChatsItem")
  const _component_NavbarItem = _resolveComponent("NavbarItem")
  const _component_NavbarList = _resolveComponent("NavbarList", true)
  const _component_Collapse = _resolveComponent("Collapse")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["navbar-list", [$props.type]])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, ind) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.route,
        class: "item"
      }, [
        ($props.type === 'chats')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_1, _toDisplayString(item.title), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (chat) => {
                return (_openBlock(), _createBlock(_component_ChatsItem, {
                  key: chat.store.id,
                  chat: chat.store,
                  active: $options.isCurrentRoute(chat),
                  onClick: _withModifiers($event => ($options.toLink(chat.route, chat.query)), ["prevent"]),
                  onShow: _cache[0] || (_cache[0] = $event => (_ctx.$emit('show', $event)))
                }, null, 8 /* PROPS */, ["chat", "active", "onClick"]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_NavbarItem, {
                children: item.children?.length || 0,
                level: $props.level,
                title: item.title,
                active: $options.isCurrentRoute(item),
                icon: item.icon,
                opened: $data.opened[ind],
                store: item.store,
                remove: item.remove,
                onArrow: $event => ($data.opened[ind] = !$data.opened[ind]),
                onClick: $event => (item.is_link ? $options.onLinkClick(ind, item) : $options.onNotLinkClick(ind))
              }, null, 8 /* PROPS */, ["children", "level", "title", "active", "icon", "opened", "store", "remove", "onArrow", "onClick"]),
              _createCommentVNode(" self recursion "),
              (item.children?.length)
                ? (_openBlock(), _createBlock(_component_Collapse, {
                    key: 0,
                    open: $data.opened[ind]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NavbarList, {
                        type: item.type,
                        class: "children",
                        items: item.children,
                        level: $props.level + 1,
                        onShow: _cache[1] || (_cache[1] = $event => (_ctx.$emit('show', $event)))
                      }, null, 8 /* PROPS */, ["type", "items", "level"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["open"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}